import { EDIT_CATEGORY_SUCCESS } from 'actions/types';
const REFRESH_GRAPH_CATEGORIES = ['income', 'internal'];
export const checkIfNeedToRefreshMonthlyTotals = (action, excludedCategoryIds = new Set()) => {
    if (action.type === EDIT_CATEGORY_SUCCESS) {
        const editCategoryAction = action;
        const needsRefresh = (categoryId) => REFRESH_GRAPH_CATEGORIES.includes(categoryId) ||
            excludedCategoryIds.has(categoryId);
        return (needsRefresh(editCategoryAction.extra.category.id) ||
            Object.values(editCategoryAction.extra.data).some(needsRefresh));
    }
    return true;
};
